import { useState } from "react";

export function useForm({ initialErrors, initialValues } = {}) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [values, setValues] = useState(initialValues ?? {});
    const [errors, setErrors] = useState(initialErrors ?? {});
    
    const setFieldValue = (key, value) => {
        setValues((oldValues) => ({ ...oldValues, [key]: value }));
    };

    const setFieldError = (key, value) => {
        setErrors((oldErrors) => ({ ...oldErrors, [key]: value }));
    };

    const handleChange = (event) => {
        setFieldValue(event.target.name, event.target.value);
    };

    return {
        isLoading, setIsLoading,
        error, setError,
        errors, setErrors, setFieldError,
        values, setValues, setFieldValue,
        handleChange
    };
}